import { useRequisitions } from '@hook'
import { RequisitionItem } from '@type/requisitions.type'
import { Button, Modal } from '@ui'
import { getError, showToast } from '@util'
import { TextArea } from 'grommet'
import { useMemo, useState } from 'react'

type Props = {
  onClose: () => void
  requisitionId?: string
  selectedItems?: RequisitionItem[]
}

export const DeclineRequisition = ({ onClose, requisitionId = '', selectedItems = [] }: Props) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [declineReason, setDeclineReason] = useState('')
  const { reviewRequisition } = useRequisitions()

  const normalizedItems = useMemo(
    () => selectedItems.filter(item => item.id !== undefined && item.id !== null),
    [selectedItems]
  )

  const submit = async () => {
    if (!requisitionId || normalizedItems.length === 0) {
      showToast('No pending requisition selected')
      return
    }

    setIsSubmitting(true)
    try {
      await reviewRequisition({
        id: requisitionId,
        payload: {
          data: {
            type: 'requisition',
            attributes: {
              note: declineReason || undefined,
              items: normalizedItems.map(item => ({
                approved_quantity: '0',
                id: String(item.id),
                status: 'declined'
              }))
            }
          }
        }
      })

      showToast('Requisition item(s) declined successfully')
      onClose()
    } catch (error) {
      getError(error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Modal onClose={onClose} title="Decline Requisitions">
      <div className="p-6 w-full max-w-[600px]">
        <label className="text-sm font-medium">Reason for Declining</label>
        <TextArea
          className="mt-3 w-full min-h-[160px] border border-[#CCCCCC] rounded-xl px-4 py-3 outline-none focus:border-[#999999]"
          onChange={event => setDeclineReason(event.target.value)}
          value={declineReason}
        />
      </div>
      <div className="border-t border-[#E5E5E5] px-6 py-4 flex items-center justify-end h-fit gap-3">
        <Button kinds="secondary" label="Cancel" onClick={onClose} size="wide" />
        <Button className="!bg-[#EB5757]" isLoading={isSubmitting} label="Decline" onClick={submit} size="wide" />
      </div>
    </Modal>
  )
}
